import { FC, ReactNode } from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

import { DashboardTypography } from "@/dashboard-design-system/Typography/DashboardTypography";

interface RateOptionsGroupProps {
  title: string;
  beforeRows?: ReactNode;
  children?: ReactNode;
}

export const RateOptionsGroup: FC<RateOptionsGroupProps> = ({ title, beforeRows, children }) => {
  return (
    <Stack spacing={1}>
      <DashboardTypography variant="body2" vibe="text-neutral-quiet" sx={{ textTransform: "uppercase" }}>
        {title}
      </DashboardTypography>
      {beforeRows}
      {children && (
        <Box
          sx={(theme) => ({
            backgroundColor: theme.palette.surface.neutral.supershy,
            border: `1px solid ${theme.palette.border.neutral.quiet}`,
            borderRadius: theme.radius(1),
            overflow: "hidden",
            "& > * + *": {
              borderTop: `1px solid ${theme.palette.border.neutral.quiet}`,
            },
          })}
        >
          {children}
        </Box>
      )}
    </Stack>
  );
};
